import axios from 'axios';
import { useEffect, useState } from 'react';
import { HotlineConfig } from './HotlineConfig';

export function useHotlineConfig(): HotlineConfig | undefined {
  const [currentConfig, setCurrentConfig] = useState<HotlineConfig | undefined>(undefined);

  useEffect(() => {
    if (!currentConfig) {
      axios.get('/config/hotline-config.json', {baseURL: process.env.PUBLIC_URL})
           .then(response => response.data)
           .then(config => setCurrentConfig(config));
    }
  }, [currentConfig]);

  return currentConfig;
}
